import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const usdFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

/**
 * Converts deprecated HTML elements in a Document to their HTML5 equivalents
 */
export function convertToHTML5(doc: Document): Document {
    // Transform <font> tags
    doc.querySelectorAll('font').forEach((fontEl) => {
        if (!fontEl.parentNode) {
            return;
        }

        const span = doc.createElement('span');
        const style = [];

        // Convert color attribute
        if (fontEl.getAttribute('color')) {
            style.push(`color: ${fontEl.getAttribute('color')}`);
        }

        // Convert size attribute
        if (fontEl.getAttribute('size')) {
            const size = fontEl.getAttribute('size');
            if (size) {
                const fontSize =
                    {
                        '1': '0.75rem',
                        '2': '0.875rem',
                        '3': '1rem',
                        '4': '1.125rem',
                        '5': '1.25rem',
                        '6': '1.5rem',
                        '7': '2rem',
                    }[size] || '1rem';
                style.push(`font-size: ${fontSize}`);
            }
        }

        // Convert face attribute
        if (fontEl.getAttribute('face')) {
            style.push(`font-family: ${fontEl.getAttribute('face')}`);
        }

        if (style.length) {
            span.setAttribute('style', style.join(';'));
        }

        // Move all children to the new span
        while (fontEl.firstChild) {
            span.appendChild(fontEl.firstChild);
        }

        fontEl.parentNode.replaceChild(span, fontEl);
    });

    return doc;
}

export function formatCurrency(amount: number, currency = 'USD', locale = 'en-US'): string {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
}

export function truncate(str: string, maxLength: number, ending = '...') {
    if (str.length <= maxLength) {
        return str;
    }
    return str.slice(0, maxLength) + ending;
}
